export * from './attachedfile.component';
